var map = {
	"./aiSecurity/cn.json": [
		3324,
		49
	],
	"./dataLeakage/cn.json": [
		3325,
		52
	],
	"./ppd/cn.json": [
		3326,
		55
	],
	"./ransomware/cn.json": [
		3327,
		58
	],
	"./socialMedia/cn.json": [
		3328,
		61
	],
	"./whatsApp/cn.json": [
		3329,
		64
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 530;
module.exports = webpackAsyncContext;